import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import SideNav from "../../components/commonComponents/Sidebar/SideNav";
import TableauDash from "../../components/commonComponents/TableauDashboard/TableauDash";
import { filterRangeValue } from "../../api_calls/TableauVisuals";
import DurationFilter from "./Filters/DurationFilter";
import { StickyTopRowStack, StickyTopRowStackSpaceBetween, StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import StoreFilter from "../../components/commonComponents/Filters/StoreFilter";
import DateRangeFilter from "../../components/commonComponents/Filters/DateRangeFilter";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../api_calls/userManagement";
import SingleSelectStoreFilter from "../../components/commonComponents/Filters/SingleSelectStoreFilter";
import { findEmbeddableId, findStoreIds } from "../../api_calls/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  dbFormatDate,
  formatToStandardDate,
  resetBrandReportView,
  standardFormatToday,
  storeListOptionsForFilter,
  yesterdayDate,
} from "../../api_calls/utils";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import DateRangeInputFields from "../../components/commonComponents/Filters/DateRangeInputFields";
import { deleteItems } from "../../Store/actions";
import { resolveEmbeddableNumberRoot } from "../../api_calls/retailerSelection";
import platformConfig from "../../platformConfig";

const Duration = () => {
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});
  const { date_range_start_date, date_range_end_date } = userStateDate;
  const dispatchAction = useDispatch();
  const numberRoot = resolveEmbeddableNumberRoot(userInfo.root_company_id);

  const { minSelectableDate, maxSelectableDate } = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = date_range_start_date
      ? new Date(date_range_start_date)
      : new Date("2023-02-07");

    const end = date_range_end_date
      ? new Date(date_range_end_date)
      : dbFormatDate(yesterday);

    return {
      minSelectableDate: start,
      maxSelectableDate: end,
    };
  }, [date_range_start_date, date_range_end_date]);

  const dashboardVariables = () => {
    let instoreDurationDashboardVariables = {};

    if (typeof userStateDate.embedded_instore_duration_stores !== "undefined" && typeof userStateDate.embedded_instore_duration_stores.store_ids !== "undefined" && userStateDate.embedded_instore_duration_stores.store_ids.length !== 0) {
      instoreDurationDashboardVariables = {
        ...instoreDurationDashboardVariables,
        Stores: userStateDate.embedded_instore_duration_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_instore_duration_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_instore_duration_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      instoreDurationDashboardVariables = {
        ...instoreDurationDashboardVariables,
        Date: {
          from: userStateDate?.embedded_instore_duration_date.from,
          to: endDate
        },
      }
    }

    return instoreDurationDashboardVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    resetBrandReportView();
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);
  return (
    <StyledMainBox component="main">
      {/* ------------- filters -------------- */}
      <StickyTopRowStackSpaceBetween
        spacing={2}
        direction={"row"}
        sx={{
          justifyContent: "flex-end",
        }}
      >
        {/* ------------- dashboard filters ----------- */}
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", ml: "auto" }}>
          {/* ----------- duration filter ---------- */}
          {/* <Box sx={{ width: 250 }}>
          <DurationFilter vizId={"durationViz"} />
        </Box> */}
          {/* ------- stores filter ----------- */}
          <Box sx={{ width: 250 }}>
            <StoreFilter
              usedFor={"retail-analytics-journey"}
              reduxKeywordToSaveValue={"embedded_instore_duration_stores"}
            />
          </Box>
          {/* ------------ day timestamp filter ------------ */}
          {typeof userStateDate.date_range_start_date !== "undefined" && (
            <Box sx={{ width: 250 }}>
              <DateRangeInputFields
                minSelectableDate={minSelectableDate}
                maxSelectableDate={maxSelectableDate}
                reduxKeywordToSaveValue={"embedded_instore_duration_date"}
              />
            </Box>
          )}

        </Box>

      </StickyTopRowStackSpaceBetween>
      {/* ---------- to have a gap between top bar and main container ---------- */}
      <Box height={1} />

      {/* ----------- tableau dashboard ---------- */}
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" &&
          typeof userStateDate.store_dates !== "undefined" &&
          typeof userStateDate.embedded_instore_duration_stores !== "undefined" && (
            <Dashboard
              key={numberRoot}
              embedDashboardId={findEmbeddableId("retail_analytics", "instore_duration")}
              variables={dashboardVariables()}
              filterConfig={{
                "number_root": numberRoot,
              }} />
          )}
      </Grid>
    </StyledMainBox>
  );
};
// remove array if all user types are allowed. if only some are allowed, add them like below
export default AccessControl(Duration, ["analytics_can_view"], platformConfig.retailAnalyticsAvailableFor, ["retail_analytics_section", "instore_duration"]);
